<ng-container [ngSwitch]="notification.payload.attributes.notification_type">
  <app-notification-template [notification]="notification" type="warning" *ngSwitchCase="'tracking_urls_google_ads_new_campaigns'">
    <ng-container message>
      {{ 'tracking_urls.campaigns_url_not_found' | translate:{ nb_campaigns: parameters.length } }} (<img [src]="data_source.attributes.icon_small"> {{ data_source.attributes.name }})
      <mat-icon class="cursor mat-icon material-icons-outlined color-grey-light color-black-hover icon-info" customToolTip [contentTemplate]="tooltip">info</mat-icon>
    </ng-container>
    <ng-container action>
      <div class="actions-container" *ngIf="data_set_usage">
        <a appClickStopPropagation (click)="onAddTrackingClick()">{{ 'tracking_urls.modify_urls' | translate }}</a>
      </div>
    </ng-container>
  </app-notification-template>
  <app-notification-template [notification]="notification" type="info" *ngSwitchCase="'tracking_urls_google_ads_campaigns_modified'">
    <ng-container message>
      {{ 'tracking_urls.campaigns_url_appended' | translate:{ nb_campaigns: parameters.length } }}
      (<img [src]="data_source.attributes.icon_small"> {{ data_source.attributes.name }})
      <mat-icon class="cursor mat-icon material-icons-outlined color-grey-light color-black-hover icon-info" customToolTip [contentTemplate]="tooltip">info</mat-icon>
    </ng-container>
  </app-notification-template>
</ng-container>
<ng-template #tooltip>
  <div *ngFor="let parameter of parameters">{{ parameter.external_name }}</div>
</ng-template>
